import { useCtx } from '@reatom/npm-react'
import { useDrag } from '@use-gesture/react'
import { useMotionValue } from 'motion/react'
import { useEffect } from 'react'

import type { AtomMut } from '@reatom/framework'

export const useTradingChartResizing = ({
  minHeight,
  maxHeight,
  heightAtom,
}: {
  heightAtom: AtomMut<number>
  minHeight: number
  maxHeight: number
}) => {
  const ctx = useCtx()

  const heightMotionValue = useMotionValue(ctx.get(heightAtom))
  const bind = useDrag(
    (state) => {
      const nextHeight = heightMotionValue.get() + state.delta[1]
      const direction = state.delta[1] > 0 ? 'down' : 'up'
      if (direction === 'down' && nextHeight > maxHeight) {
        return
      }
      if (direction === 'up' && nextHeight < minHeight) {
        return
      }

      heightMotionValue.set(nextHeight)
      // sync with atom on end of drag
      if (!state.dragging) {
        heightAtom(ctx, nextHeight)
      }
    },
    { axis: 'y' },
  )

  useEffect(() => {
    const unsubscribe = heightAtom.onChange((ctx, height) => {
      heightMotionValue.set(height)
    })
    heightMotionValue.set(ctx.get(heightAtom))
    return () => unsubscribe()
  }, [ctx, heightAtom, heightMotionValue])

  return {
    heightMotionValue,
    bindHandle: bind,
  }
}
